// extracted by mini-css-extract-plugin
export default {"wrapper":"LinkPromo_wrapper__b7QS6","promoHeader":"LinkPromo_promoHeader__hWX-J","linkWrapper":"LinkPromo_linkWrapper__GVm5u"};